import "./OfficeCell.css";
import { Company } from "../models/company";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../i18n/UseTranslation";

function OfficeCell({ company }: { company: Company }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleCellClick = (e: React.MouseEvent) => {
    e.preventDefault();

    const targetId = company?.uuid || (company as any)?.company_uuid;

    if (targetId) {
      navigate(`/offices/${targetId}`);
    }
  };

  return (
    <div
      className="office-card"
      onClick={handleCellClick}
      style={{ cursor: "pointer" }}
    >
      <h2 className="office-title">
        🏢 {company?.name || t.officeCell.noName}
      </h2>
      <p className="office-platform-status">
        {company?.is_platform
          ? `🛡️ ${t.officeCell.mainPlatform}`
          : `🏢 ${t.officeCell.standardCorporate}`}
      </p>
    </div>
  );
}

export default OfficeCell;
